import { Stack, ToggleButton, ToggleButtonGroup, Typography } from "@mui/material";

import { brandRed, ink, paper, redDeep, stone } from "../pricing-reports/design/designTokens";
import PricingReportFilters from "../pricing-reports/PricingReportFilters";
import { VERIFY_PRICE_VERIFIED_VIEW_OPTIONS } from "./verifyPriceUtils";

export default function VerifyPriceFilters(props) {
  const { humanVerifiedView, setHumanVerifiedView, ...filterProps } = props;

  return (
    <PricingReportFilters
      {...filterProps}
      title="Verify Price"
      description="Review individual price history records. Filter by date, product, province, retailer, provider, and verification status."
      extraFilters={
        <Stack spacing={0.75} sx={{ mt: 1 }}>
          <Typography variant="caption" color="text.secondary" id="verify-price-status-label">
            Human verified
          </Typography>
          <ToggleButtonGroup
            exclusive
            size="small"
            value={humanVerifiedView}
            onChange={(_, nextView) => {
              if (!nextView) return;
              setHumanVerifiedView(nextView);
            }}
            aria-labelledby="verify-price-status-label"
            sx={{
              flexWrap: "wrap",
              "& .MuiToggleButton-root": {
                borderRadius: 0,
                textTransform: "none",
                px: 1.75,
                color: ink,
                borderColor: stone,
                "&.Mui-selected": {
                  backgroundColor: brandRed,
                  color: paper,
                  "&:hover": {
                    backgroundColor: redDeep,
                  },
                },
              },
            }}
          >
            {VERIFY_PRICE_VERIFIED_VIEW_OPTIONS.map((option) => (
              <ToggleButton key={option.value} value={option.value}>
                {option.label}
              </ToggleButton>
            ))}
          </ToggleButtonGroup>
        </Stack>
      }
    />
  );
}
